import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import FullScreenDialog from './FullScreenDialog'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import ListAltIcon from '@material-ui/icons/ListAlt'
import DeleteIcon from '@material-ui/icons/Delete'


const styles = (theme) => {
    return ({
        // card: {
        //     marginBottom: '20px'
        // },
        // cardTitle: {
        //     marginLeft: '15px',
        //     marginTop: '15px',
        // },
    })
};

class QueueList extends Component {
    constructor(props) {
        super(props);

        const queue = localStorage.getItem('sync_queue')
        let queue_elements = []
        if (queue) {

            queue_elements = JSON.parse(queue)['queue']
        }

        this.state = {
            queue_elements
        }

        // this.form = React.createRef();
        // this.caregiver_signature = React.createRef();
        // this.provider_signature = React.createRef();
        // this.caregiver_signature_canvas = React.createRef();
        // this.provider_signature_canvas = React.createRef();
    }

    handleOnDeleteClick = index => {
        const temp = [...this.state.queue_elements]
        temp.splice(index, 1)
        this.setState({
            queue_elements: temp
        })
    }

    handleSave = e => {
        const queue = JSON.parse(localStorage.getItem('sync_queue'))
        queue['queue'] = this.state.queue_elements
        localStorage.setItem('sync_queue', JSON.stringify(queue))
        this.props.handleClose()
    }

    render() {

        const { classes } = this.props;

        const items = []

        const queue_elements = this.state.queue_elements

        // for (let index = 0; index < this.props.visits.length; index++) {
        for (let index in queue_elements) {
            const element = queue_elements[index];
            items.push(
                <ListItem className={classes.line} key={'item-' + element['id']}>
                    <ListItemAvatar>
                        <Avatar>
                            <ListAltIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        primary={
                            element.action
                        }
                        secondary={
                            element.last_error
                        }
                    />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete" onClick={() => this.handleOnDeleteClick(index)}>
                            <DeleteIcon />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            )
        }

        return (
            <FullScreenDialog
                open={true}
                title={'Queue'}
                bodyPadding="20px"
                handleClose={this.props.handleClose}
                handleSave={this.handleSave}
            >
                <div style={{minWidth: 300}}>
                    {
                        items.length ?
                            <React.Fragment>
                                <List className={classes.root}>
                                    {items}
                                </List>
                            </React.Fragment>
                            :
                            <div style={{textAlign: 'center'}}>No pending syncronization tasks</div>
                    }
                </div>

            </FullScreenDialog>
        )
    }
}

export default withStyles(styles)(QueueList);